import { createRoute } from '@tanstack/react-router'

import { StaticRouteParameter } from 'config/routing'
import { Overview } from 'domains/MediaPlatforms/Settings/Regions'
import { mediaPlatformSettingsLayoutRoute } from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/Settings'

export const mediaPlatformSettingsRegionsRoute = createRoute({
  getParentRoute: () => mediaPlatformSettingsLayoutRoute,
  path: StaticRouteParameter.REGIONS,
  loader: () => null,
})

export const mediaPlatformSettingsRegionsOverviewRoute = createRoute({
  getParentRoute: () => mediaPlatformSettingsRegionsRoute,
  path: '/',
  component: Overview,
})
